import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'neutral' | 'destructive' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading,
  leftIcon,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-[4px] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#0176d3] text-white hover:bg-[#014486] focus:ring-[#0176d3]',
    secondary: 'bg-white text-[#0176d3] border border-[#0176d3] hover:bg-[#f3f2f2] focus:ring-[#0176d3]',
    neutral: 'bg-white text-[#3e3e3c] border border-[#dddbda] hover:bg-[#f3f2f2] focus:ring-[#dddbda]',
    destructive: 'bg-[#ba0517] text-white hover:bg-[#8e030f] focus:ring-[#ba0517]',
    ghost: 'bg-transparent text-[#0176d3] hover:bg-[#f3f2f2] hover:underline'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-9 px-4 text-sm',
    lg: 'h-11 px-6 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-171">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-172" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-173">{leftIcon}</span>}
      {children}
    </button>;
}